import firebase from 'firebase/app';
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/analytics';
import {firebase_cred} from "../credentials/credential";


const cred = firebase_cred.production
    ? firebase_cred.firebase.prod
    : firebase_cred.firebase.dev;

firebase.initializeApp(cred);

let fbAnalytics = null;

if (firebase_cred.production) {
    fbAnalytics = firebase.analytics();
}

const db = firebase.firestore();
const auth = firebase.auth();
export {
    db,
    fbAnalytics,
    auth
}
